import { SagaIterator } from 'redux-saga';
import { all, takeLatest } from 'redux-saga/effects';
import { FETCH_EXPO } from '../actions';
import fetchExpoWorker from './fetch-expo-worker';

export default function* publicExpoWatcher(): SagaIterator {
  yield all([takeLatest(FETCH_EXPO, fetchExpoWorker)]);
}
